import { Controller } from "@hotwired/stimulus";

export default class SalesAccordionController extends Controller {
  static targets = ["item", "content", "icon", "header"];
  static values = { open: String };

  states = {
    OPEN: "open",
    CLOSED: "closed",
  };

  iconMap = {
    open: "fa-chevron-up",
    closed: "fa-chevron-down",
  };

  iconClasses = ["fa-chevron-up", "fa-chevron-down"];

  contentSelector = "[data-sales-accordion-target='content']";
  iconSelector = "[data-sales-accordion-target='icon']";
  itemSelector = "[data-sales-accordion-target='item']";

  connect() {
    this.initializeItems();
    this.openSectionFromValue();
  }

  openSectionFromValue() {
    if (!this.openValue) return;

    const item = this.itemTargets.find(
      (item) => item.dataset.section === this.openValue
    );
    if (item) {
      this.setState(item, this.states.OPEN);
      item.scrollIntoView({ behavior: "instant", block: "start" });
    }
  }

  initializeItems() {
    this.itemTargets.forEach((item) => {
      if (!item.dataset.state) {
        item.dataset.state = this.states.CLOSED;
      }
      this.updateContentVisibility(item);
      this.updateIcon(item);
    });
  }

  toggle(event) {
    // Don't toggle if clicking on a link or button
    if (event.target.closest("a, button")) {
      return;
    }

    event.preventDefault();
    const item = event.currentTarget.closest(this.itemSelector);
    const currentState = item.dataset.state;

    if (currentState !== this.states.OPEN) {
      this.closeAllItems();
    }

    this.toggleItem(item, currentState);
  }

  toggleItem(item, currentState) {
    const { OPEN, CLOSED } = this.states;

    switch (currentState) {
      case CLOSED:
        this.setState(item, OPEN);
        break;
      case OPEN:
        this.setState(item, CLOSED);
        break;
    }
  }

  setState(item, newState, activate = false) {
    item.dataset.state = newState;
    if (activate) {
      item.dataset.active = "true";
    }
    this.updateContentVisibility(item);
    this.updateIcon(item);
  }

  closeAllItems() {
    this.itemTargets.forEach((item) => {
      if (item.dataset.state === this.states.OPEN) {
        this.setState(item, this.states.CLOSED);
      }
    });
  }

  updateContentVisibility(item) {
    const content = item.querySelector(this.contentSelector);
    if (!content) return;

    const shouldShow = item.dataset.state === this.states.OPEN;
    content.classList.toggle("hidden", !shouldShow);
  }

  updateIcon(item) {
    const iconContainer = item.querySelector(this.iconSelector);
    if (!iconContainer) return;

    const iconElement = iconContainer.querySelector('[class*="fa-"]');
    if (!iconElement) return;

    iconElement.classList.remove(...this.iconClasses);
    iconElement.classList.add(this.getIconClass(item.dataset.state));
  }

  getIconClass(state) {
    return this.iconMap[state] || this.iconMap[this.states.CLOSED];
  }
}
